// schema/marks/underline.ts
var UNDERLINE_SCHEMA = () => ({
  parseDOM: [{ tag: "u" }, { style: "text-decoration=underline" }],
  toDOM: () => ["u"]
});
var UNDERLINE_KEY = "underline";
var UNDERLINE = {
  [UNDERLINE_KEY]: UNDERLINE_SCHEMA
};
export {
  UNDERLINE,
  UNDERLINE_KEY,
  UNDERLINE_SCHEMA
};
